module.exports = __webpack_public_path__ + "media/images/responsive/keywords/keyword_rekishitekikenzobutu-48b7277bdd5a19b6ca142dae132035c7.jpg";